import { gql } from "@apollo/client";

export const CREATE_SCHEDULE = gql`
  mutation createSchedule($data: CreateScheduleInput!) {
    createSchedule(data: $data) 
  }
`

export const CREATE_OVERRIDE_SCHEDULE = gql`
  mutation createOverrideSchedule($data: CreateScheduleInput!) {
    createOverrideSchedule(data: $data) 
  }
`

export const GET_SCHEDULES = gql`
  query schedules($data: SchedulesInput!) {
    schedules(data: $data) {
      id
      startDate
      endDate
      patientId
      sfPatientId
      override
      rigid
      flexibility
      scheduleTimes {
        id
        startTime
        endTime
        day
        caregiverId
        sfCaregiverId
        sfCaregiver {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const DELETE_SCHEDULE = gql`
  mutation deleteSchedule($id: ID!) {
    deleteSchedule(id: $id)
  }
`

export const UPDATE_SCHEDULE = gql`
  mutation updateSchedule($data: UpdateScheduleInput!) {
    updateSchedule(data: $data)
  }
`
export const GET_SCHEDULES_BY_CAREGIVER_ID = gql`
  query schedulesByCaregiverId($data: SchedulesByCaregiverInput!) {
    schedulesByCaregiverId(data: $data) {
      id
      startDate
      endDate
      patientId
      sfPatientId
      patient {
        id
        firstName
        lastName
      }
      override
      rigid
      flexibility
      scheduleTimes {
        id
        startTime
        endTime
        day
        caregiverId
        sfCaregiverId
      }
    }
  }
`
